import { render, staticRenderFns } from "./loginLayout.vue?vue&type=template&id=b928082c&scoped=true&"
var script = {}
import style0 from "./loginLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./loginLayout.vue?vue&type=style&index=1&id=b928082c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b928082c",
  null
  
)

export default component.exports